import React, { useMemo } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { makeStyles } from "@material-ui/core";

const CustomMonthYearPicker = ({
  onChange,
  minDate,
  maxDate,
  value,
  label,
  errorText,
  isError,
  variant = "date",
  clearable = false,
  views,
  ...rest
}) => {
  const pickerViews =
    views ||
    (variant === "month"
      ? ["year", "month"]
      : variant === "year"
      ? ["year"]
      : ["year", "month", "day"]);

  const useStyles = makeStyles({
    root: {
      "& .MuiInputBase-root": {
        "& .MuiInputBase-input": {
          paddingTop: 10,
          paddingBottom: 10,
        },
      },
      "& .MuiInputLabel-formControl": {
        top: "-5px",
      },

      "& .MuiFormControl-fullWidth": {
        width: "100%",
      },
    },
  });
  const classes = useStyles();

  const mD = useMemo(() => {
    if (maxDate) return maxDate;
    const d = new Date();
    d.setFullYear(d.getFullYear());
    return d;
  }, [maxDate]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        clearable
        label={label}
        inputVariant={"outlined"}
        className={classes.root}
        id="time-picker"
        fullWidth
        value={value || null}
        onChange={(newValue) => onChange(newValue)}
        views={pickerViews}
        minDate={minDate}
        maxDate={mD}
        {...rest}
      />
      {errorText ? (
        <p style={{ textAlign: "right", marginTop: "-1px", color: "#FF0000" }}>
          {errorText}
        </p>
      ) : (
        ""
      )}
    </LocalizationProvider>
  );
};

export default CustomMonthYearPicker;
